import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LiiferLogoSvg from "../../assets/svg/liifer-burger-logo.svg";
import { FiveDollarsOffPreSignupModal } from "components/promo/FiveDollarsOffPreSignupModal";
import OverwolfLogo from "../../assets/images/Overwolf-logo.png";
import { useAppSelector } from "store/hooks";

type Props = {
  hideLabel?: boolean;
  centered?: boolean;
  boldText?: boolean;
};

export const downloadLink =
  "https://download.overwolf.com/install/Download?Name=Liifer+-+Food+Order&ExtensionId=jcedejgjifggfepoinicmboalnkldjcledokcdci&Channel=web_dl_btn";

export const InGameAppDownloadButton: React.FC<Props> = ({ centered }) => {
  const { t } = useTranslation();
  const [
    showFiveDollarsOffPreSignupModal,
    setShowFiveDollarsOffPreSignupModal,
  ] = useState<boolean>(false);
  const promoCode = localStorage
    .getItem("promoCode")
    ?.includes("SIGNUP_DISCOUNT_5");
  const { accessToken } = useAppSelector((state) => state.auth);

  return (
    <div>
      <FiveDollarsOffPreSignupModal
        showModal={showFiveDollarsOffPreSignupModal}
        setShowModal={setShowFiveDollarsOffPreSignupModal}
        downloadLink={downloadLink}
        promoCode={localStorage.getItem("promoCode")}
      />
      <div
        className={`flex flex-col ${
          !!centered ? "items-center" : "items-start"
        } space-y-2 `}
        id="Download-Liifer-App"
      >
        <button
          onClick={() => {
            if (promoCode) {
              setShowFiveDollarsOffPreSignupModal(true);
            } else {
              window.location.href = downloadLink;
            }
          }}
          className={`${
            accessToken
              ? "hover:opacity-70 transition ease-in-out duration-200"
              : "hover:scale-105 duration-1000"
          } bg-white space-x-2 shadow-lg flex items-center text-black font-semibold rounded-2xl px-5 py-3 3xl:py-4 3xl:px-8`}
          id="Download-Liifer-App"
        >
          <img
            className="h-6 3xl:h-7"
            src={LiiferLogoSvg}
            alt="windows"
            id="Download-Liifer-App"
          />
          {accessToken ? (
            <span
              className="text-sm lg:text-base whitespace-nowrap"
              id="Download-Liifer-App"
            >
              {t("landingPage.downloadInGameApp")}
            </span>
          ) : (
            <>
              <span
                className="text-sm lg:text-base 3xl:text-xlg whitespace-nowrap"
                id="Download-Liifer-App"
              >
                {t("landingPage.downloadInGameAppOverwolf")}
              </span>
              <img
                src={OverwolfLogo}
                id="Download-Liifer-App"
                className="h-6 3xl:h-7"
                alt="Overwolf Logo"
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default InGameAppDownloadButton;
